import './index.less';

import classNames from 'classnames';
import React from 'react';

export type RevxOverlayProps = {
  children?: React.ReactNode;
  className?: string;
  style?: object;
};

export const RevxOverlay = (props: RevxOverlayProps) => {
  return (
    <div
      className={classNames('revx-overlay', props.className)}
      style={props.style}
    >
      {props.children}
    </div>
  );
};
